<template>
    <div class="topbarmain">
        <div class="topbar">
            <el-dropdown trigger="click" :placement="brandDropdownPlacement" @command="onBrandCommand" class="topbar-brand-dropdown">
                <span class="topbar-brand">
                    <img src="../assets/db.png" alt="" class="topbar-logo">
                    <span class="topbar-title">顶伯软件</span>
                    <i class="el-icon-arrow-down topbar-brand-arrow"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="topbar-tools-menu">
                    <el-dropdown-item command="/"><i class="el-icon-s-home"></i> 首页</el-dropdown-item>
                    <el-dropdown-item v-for="(item, index) in toolList" :key="index" :command="item.address">
                        <i class="el-icon-s-tools"></i> {{ item.toolname }}
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>

            <nav class="topbar-nav">
                <router-link to="/solutions" class="topbar-item topbar-solution-link"><i class="el-icon-reading"></i> 解决方案</router-link>
                <router-link to="/" class="topbar-item"><i class="el-icon-s-home"></i> 首页</router-link>

                <template v-if="$store.state.user">
                    <a class="topbar-item topbar-checkin" :class="{ 'checkin-done': $store.state.checkedInToday }" @click="doCheckin">
                        <i :class="$store.state.checkedInToday ? 'el-icon-circle-check' : 'el-icon-check'"></i>
                        {{ $store.state.checkedInToday ? '已签到' : '签到领币' }}
                    </a>
                    <a class="topbar-item" @click="openPayDialog"><i class="el-icon-coin"></i> 购买金币</a>
                    <el-dropdown trigger="click" placement="bottom-end" @command="onEarnCoinCommand" class="topbar-earn-dropdown">
                        <span class="topbar-item topbar-earn-trigger">
                            <i class="el-icon-present"></i> 赚金币
                            <i class="el-icon-arrow-down topbar-earn-arrow"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="topbar-earn-menu">
                            <el-dropdown-item command="scan-code"><i class="el-icon-view"></i> 扫码看视频赚金币</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>

                <a class="topbar-item" @click="showqq = true"><i class="el-icon-chat-dot-round"></i> 联系我们</a>
                <a class="topbar-item topbar-darkmode" @click="toggleDarkMode" :title="$store.state.darkMode ? '切换到浅色模式' : '切换到深色模式'">
                    <i :class="$store.state.darkMode ? 'el-icon-sunny' : 'el-icon-moon'"></i>
                </a>

                <template v-if="!$store.state.user">
                    <a class="topbar-item topbar-btn" @click="openLogin('login')"><i class="el-icon-user"></i> 登录</a>
                    <a class="topbar-item topbar-btn primary" @click="openLogin('register')"><i class="el-icon-edit-outline"></i> 新用户注册</a>
                </template>

                <span class="topbar-user-wrap" v-else>
                    <router-link to="/user" class="topbar-user-link">
                        <i class="el-icon-user-solid"></i>
                        {{ $store.state.user.username }}
                        <span class="topbar-user-coins">（{{ $store.state.user.coins }} 金币）</span>
                    </router-link>
                    <a class="topbar-item topbar-logout" @click="confirmLogout"><i class="el-icon-switch-button"></i> 退出</a>
                </span>
            </nav>
        </div>

        <LoginRegisterDialog />

        <el-dialog :visible.sync="showqq" :width="showwidth" center class="contact-dialog">
            <div slot="title" class="dialog-title">
                <i class="el-icon-chat-dot-round"></i>
                <span>联系我们</span>
            </div>
            <div class="dialog-body">
                <div class="dialog-tip">
                    <i class="el-icon-chat-line-round"></i>
                    <span>如果您对我们的系统有更好的意见或建议，请用手机微信扫描下方二维码加入群聊，让我们一起完善它。</span>
                </div>
                <div class="dialog-qr-wrap">
                    <img class="dialog-qr" src="@/assets/wechat.jpg" alt="微信扫码加群">
                </div>
                <div class="dialog-footer">
                    <el-button type="primary" icon="el-icon-check" @click="showqq = false">知道了</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="showCheckinQrDialog" :width="showwidth" center class="checkin-qr-dialog" @close="checkCheckinStatus">
            <div slot="title" class="dialog-title">
                <i class="el-icon-present"></i>
                <span>小程序签到</span>
            </div>
            <div class="dialog-body">
                <div class="dialog-tip checkin-qr-tip">
                    <i class="el-icon-mobile-phone"></i>
                    <span>请使用微信扫描下方二维码前往{{ miniProgramTitle }}签到，小程序领取到的金币更多。</span>
                </div>
                <div class="dialog-qr-wrap checkin-qr-wrap">
                    <img class="dialog-qr" :src="miniProgramCheckinQr" alt="小程序签到二维码">
                </div>
                <div class="dialog-footer">
                    <el-button @click="showCheckinQrDialog = false">稍后再签</el-button>
                    <el-button type="primary" icon="el-icon-check" @click="showCheckinQrDialog = false">我知道了</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import LoginRegisterDialog from './LoginRegisterDialog.vue'
import { toolList } from '@/config/tools.js'
import { MINIPROGRAM_CHECKIN_QR_IMAGE, MINIPROGRAM_WIDGET_TITLE } from '@/config'

export default {
    name: 'TopBar',
    components: { LoginRegisterDialog },
    data() {
        return {
            showqq: false,
            showCheckinQrDialog: false,
            showwidth: '80vw',
            toolList,
            isMobile: typeof window !== 'undefined' && window.innerWidth <= 768
        }
    },
    computed: {
        brandDropdownPlacement() {
            return this.isMobile ? 'bottom' : 'bottom-start'
        },
        legacyCoinFeatureEnabled() {
            return this.$store.state.legacyCoinFeatureEnabled !== false
        },
        miniProgramCoinFeatureEnabled() {
            return !!this.$store.state.miniProgramCoinFeatureEnabled
        },
        miniProgramTitle() {
            return MINIPROGRAM_WIDGET_TITLE || '微信小程序'
        },
        miniProgramCheckinQr() {
            return MINIPROGRAM_CHECKIN_QR_IMAGE
        }
    },
    created() {
        if (typeof innerWidth !== 'undefined' && innerWidth > 768) this.showwidth = '400px'
    },
    mounted() {
        this._resizeHandler = () => {
            this.isMobile = window.innerWidth <= 768
            this.showwidth = window.innerWidth > 768 ? '400px' : '80vw'
        }
        window.addEventListener('resize', this._resizeHandler)
        this.$nextTick(() => {
            this.ensureSolutionLinkOrder()
        })
        this.checkCheckinStatus()
    },
    beforeDestroy() {
        if (this._resizeHandler) window.removeEventListener('resize', this._resizeHandler)
    },
    methods: {
        ensureSolutionLinkOrder() {
            if (typeof document === 'undefined') return
            const nav = this.$el && this.$el.querySelector ? this.$el.querySelector('.topbar-nav') : null
            if (!nav) return
            const solutionLink = nav.querySelector('.topbar-solution-link')
            const contactIcon = nav.querySelector('.el-icon-chat-dot-round')
            const contactLink = contactIcon && contactIcon.closest ? contactIcon.closest('a') : null
            if (solutionLink && contactLink && solutionLink !== contactLink && solutionLink.nextElementSibling !== contactLink) {
                nav.insertBefore(solutionLink, contactLink)
            }
        },
        onBrandCommand(path) {
            if (path && path !== this.$route.path) this.$router.push(path)
        },
        openLogin(tab) {
            this.$store.commit('SetShowLoginDialog', { show: true, tab })
        },
        confirmLogout() {
            this.$confirm('确定要退出登录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                iconClass: 'el-icon-question'
            }).then(() => {
                this.logout()
            }).catch(() => {})
        },
        logout() {
            this.$store.commit('SetUser', null)
            this.$message({ message: '已退出登录', type: 'info' })
            if (this.$route.path === '/user') this.$router.replace('/')
        },
        onEarnCoinCommand(cmd) {
            if (!this.$store.state.user) {
                this.$message.warning('请先登录后再赚金币')
                this.$store.commit('SetShowLoginDialog', { show: true })
                return
            }
            if (cmd === 'scan-code') {
                if (!this.legacyCoinFeatureEnabled && !this.miniProgramCoinFeatureEnabled) {
                    this.$message.warning('当前未开启赚金币功能')
                    return
                }
                this.$store.commit('SetOpenEarnCoinDialog', true)
            }
        },
        openPayDialog() {
            if (!this.$store.state.user) {
                this.$message.warning('请先登录后再购买金币，充值的金币将进入您的账户')
                this.$store.commit('SetShowLoginDialog', { show: true })
                return
            }
            this.$store.commit('SetOpenPayDialog', true)
        },
        checkCheckinStatus() {
            const user = this.$store.state.user
            if (user && user.token) {
                this.$axios.get('/user/checkin/status', { params: { token: user.token } }).then(res => {
                    this.$store.commit('SetCheckedInToday', !!(res.data && res.data.checkedIn))
                }).catch(() => {})
            }
        },
        doCheckin() {
            if (this.$store.state.checkedInToday) {
                this.$message.info('今日已签到')
                return
            }
            const user = this.$store.state.user
            if (!user || !user.token) return
            if (this.miniProgramCoinFeatureEnabled) {
                this.showCheckinQrDialog = true
                return
            }
            if (!this.legacyCoinFeatureEnabled) {
                this.$message.warning('当前未开启签到功能')
                return
            }
            this.$axios.post('/user/checkin', { token: user.token }).then(res => {
                const data = res.data || {}
                if (data.coins != null) this.$store.commit('SetUserCoins', data.coins)
                if (data.checkedIn != null) this.$store.commit('SetCheckedInToday', !!data.checkedIn)
                this.$message({
                    message: data.message || '签到成功，已增加1金币',
                    type: data.success ? 'success' : 'info'
                })
            }).catch((err) => {
                const msg =
                    (err.response && err.response.data && err.response.data.message) ||
                    err.message ||
                    '签到失败，请稍后重试'
                this.$message({ message: msg, type: 'warning' })
            })
        },
        toggleDarkMode() {
            const newVal = !this.$store.state.darkMode
            this.$store.commit('SetDarkMode', newVal)
            const user = this.$store.state.user
            if (user && user.token) {
                this.$axios.post('/user/dark-mode', { token: user.token, darkMode: newVal ? 1 : 0 }).catch(() => {})
            }
        }
    },
    watch: {
        '$route.path'() {
            this.$nextTick(() => {
                this.ensureSolutionLinkOrder()
            })
        },
        '$store.state.openContactDialog'(open) {
            if (open) {
                this.$store.commit('SetOpenContactDialog', false)
                this.showqq = true
            }
        },
        '$store.state.user'(user) {
            if (user) {
                this.checkCheckinStatus()
            } else {
                this.$store.commit('SetCheckedInToday', false)
            }
        }
    }
}
</script>

<style lang="less" scoped>
.dialog-title {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    color: #303133;
}

.dialog-title i {
    margin-right: 8px;
    font-size: 22px;
    color: #409eff;
}

.dialog-body {
    padding: 20px 0 8px;
}

.dialog-tip {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 14px 16px;
    background: #ecf5ff;
    border: 1px solid #d9ecff;
    border-radius: 8px;
    margin-bottom: 20px;
    font-size: 14px;
    color: #606266;
    line-height: 1.6;
}

.dialog-tip i {
    font-size: 20px;
    color: #409eff;
    flex-shrink: 0;
    margin-top: 2px;
}

.dialog-qr-wrap {
    margin: 0 auto 20px;
    width: 100%;
    max-width: 280px;
    padding: 12px;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 10px;
    box-shadow: 0 2px 12px rgba(0,0,0,.06);
}

.dialog-qr {
    width: 100%;
    display: block;
    border-radius: 6px;
}

.dialog-footer {
    text-align: center;
}

.dialog-footer .el-button {
    min-width: 120px;
}

.checkin-qr-note {
    margin: -6px 0 18px;
    font-size: 12px;
    color: #909399;
    text-align: center;
    line-height: 1.6;
}

@media (min-width: 769px) {
    .topbarmain {
        background: linear-gradient(180deg, #fff 0%, #f5f7fa 100%);
        box-shadow: 0 1px 4px rgba(0,0,0,.06);
    }

    .topbar {
        max-width: 1200px;
        height: 64px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
    }

    .topbar-brand-dropdown {
        display: inline-flex;
    }

    .topbar-brand {
        display: inline-flex;
        align-items: center;
        gap: 12px;
        text-decoration: none;
        padding: 8px 12px;
        margin: -8px -12px;
        border-radius: 8px;
        cursor: pointer;
        transition: transform 0.25s ease, background 0.25s ease;
    }

    .topbar-brand:hover {
        background: rgba(64, 158, 255, 0.08);
        transform: scale(1.02);
    }

    .topbar-brand:hover .topbar-logo {
        transform: scale(1.1) rotate(-3deg);
    }

    .topbar-brand:hover .topbar-title,
    .topbar-brand:hover .topbar-brand-arrow {
        color: #409eff;
    }

    .topbar-brand .topbar-logo {
        width: 42px;
        height: 42px;
        object-fit: contain;
        transition: transform 0.25s ease;
    }

    .topbar-brand .topbar-title {
        font-size: 18px;
        font-weight: 600;
        color: #303133;
        transition: color 0.25s ease;
    }

    .topbar-brand .topbar-brand-arrow {
        font-size: 12px;
        color: #909399;
        margin-left: 2px;
        transition: color 0.2s, transform 0.2s;
    }

    .topbar-tools-menu {
        min-width: 200px;
    }

    .topbar-nav {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .topbar-item {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 8px 14px;
        font-size: 14px;
        color: #606266;
        text-decoration: none;
        border-radius: 6px;
        cursor: pointer;
        transition: color .2s, background .2s;
    }

    .topbar-item:hover {
        color: #409eff;
        background: #ecf5ff;
    }

    .topbar-solution-link {
        color: #fff !important;
        background: linear-gradient(135deg, #1f8fff 0%, #36c2ff 100%) !important;
        box-shadow: 0 8px 18px rgba(31, 143, 255, 0.18);
    }

    .topbar-solution-link:hover,
    .topbar-solution-link.router-link-active {
        color: #fff !important;
        background: linear-gradient(135deg, #1677e6 0%, #23b0f2 100%) !important;
    }

    .topbar-item.router-link-active {
        color: #409eff;
        font-weight: 500;
    }

    .topbar-item i {
        font-size: 16px;
    }

    .topbar-earn-dropdown {
        display: inline-flex;
    }

    .topbar-earn-trigger {
        display: inline-flex !important;
        align-items: center;
        gap: 4px;
    }

    .topbar-earn-arrow {
        font-size: 12px !important;
        opacity: 0.75;
    }

    .topbar-btn.primary {
        color: #fff;
        background: #409eff;
    }

    .topbar-btn.primary:hover {
        background: #66b1ff;
        color: #fff;
    }

    .topbar-user-wrap {
        display: inline-flex;
        align-items: center;
        background: #f4f4f5;
        border-radius: 6px;
        overflow: hidden;
    }

    .topbar-user-link {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 8px 12px;
        font-size: 14px;
        color: #303133;
        text-decoration: none;
        transition: background .2s;
    }

    .topbar-user-link:hover {
        background: #e9e9eb;
        color: #409eff;
    }

    .topbar-user-coins {
        color: #e6a23c;
        font-size: 13px;
        margin-left: 2px;
    }

    .topbar-logout {
        border-left: 1px solid #e4e7ed;
        margin-left: 0;
    }

    .topbar-logout:hover {
        color: #f56c6c;
        background: #fef0f0;
    }
}

@media (max-width: 768px) {
    .dialog-qr-wrap {
        max-width: 60vw;
    }

    .topbarmain {
        background: linear-gradient(180deg, #fff 0%, #f5f7fa 100%);
        box-shadow: 0 1px 3px rgba(0,0,0,.06);
    }

    .topbar {
        width: 100%;
        min-height: auto;
        padding: 14px 16px 16px;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        row-gap: 0;
        box-sizing: border-box;
    }

    .topbar-brand-dropdown {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        order: 1;
        padding-bottom: 16px;
        margin-bottom: 12px;
        border-bottom: 1px solid rgba(0,0,0,.06);
    }

    .topbar-brand-dropdown ::v-deep .el-dropdown-selfdefine {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .topbar-brand {
        padding: 6px 12px;
        margin: -6px -12px;
        gap: 12px;
        border-radius: 10px;
    }

    .topbar-brand .topbar-logo {
        width: 40px;
        height: 40px;
    }

    .topbar-brand .topbar-title {
        font-size: 18px;
        font-weight: 600;
        letter-spacing: 0.03em;
        color: #303133;
    }

    .topbar-brand .topbar-brand-arrow {
        font-size: 10px;
        margin-left: 4px;
        color: #909399;
    }

    .topbar-nav {
        width: 100%;
        order: 2;
        gap: 10px 12px;
        row-gap: 14px;
        flex-wrap: wrap;
        justify-content: flex-end;
        align-items: center;
        align-content: flex-start;
        padding-top: 4px;
        display: flex;
    }

    .topbar-item {
        padding: 9px 14px;
        font-size: 13px;
        border-radius: 8px;
        color: #606266;
        white-space: nowrap;
        display: inline-flex;
        align-items: center;
    }

    .topbar-item:hover {
        color: #409eff;
        background: #ecf5ff;
    }

    .topbar-solution-link,
    .topbar-solution-link:hover,
    .topbar-solution-link.router-link-active {
        color: #fff;
        background: linear-gradient(135deg, #1f8fff 0%, #36c2ff 100%);
        box-shadow: 0 8px 18px rgba(31, 143, 255, 0.16);
    }

    .topbar-earn-dropdown {
        display: inline-flex;
    }

    .topbar-earn-trigger {
        display: inline-flex !important;
        align-items: center;
        gap: 4px;
    }

    .topbar-earn-arrow {
        font-size: 11px !important;
    }

    .topbar-user-wrap {
        display: inline-flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;
        row-gap: 14px;
    }

    .topbar-user-link,
    .topbar-logout {
        padding: 9px 14px;
        font-size: 13px;
        border-radius: 8px;
        white-space: nowrap;
        display: inline-flex;
        align-items: center;
    }

    .topbar-user-coins {
        display: none;
    }
}

.topbar-checkin {
    color: #e6a23c !important;
}

.topbar-checkin:hover {
    color: #f5a623 !important;
    background: rgba(230, 162, 60, 0.1) !important;
}

.topbar-checkin.checkin-done {
    color: #909399 !important;
    cursor: default;
}

.topbar-checkin.checkin-done:hover {
    background: transparent !important;
    color: #909399 !important;
}

.topbar-darkmode {
    padding: 8px 10px !important;
}

.topbar-darkmode i {
    font-size: 18px !important;
}
</style>

<style lang="less">
.dark-mode .topbarmain {
    background: var(--topbar-bg) !important;
    box-shadow: 0 1px 4px var(--shadow-color) !important;
}

.dark-mode .topbar-brand .topbar-title {
    color: var(--text-primary) !important;
}

.dark-mode .topbar-brand .topbar-brand-arrow {
    color: var(--text-secondary) !important;
}

.dark-mode .topbar-brand:hover {
    background: var(--hover-bg) !important;
}

.dark-mode .topbar-brand:hover .topbar-title {
    color: #409eff !important;
}

.dark-mode .topbar-item {
    color: var(--text-regular) !important;
}

.dark-mode .topbar-item:hover {
    color: #409eff !important;
    background: var(--hover-bg) !important;
}

.dark-mode .topbar-solution-link,
.dark-mode .topbar-solution-link:hover,
.dark-mode .topbar-solution-link.router-link-active {
    color: #fff !important;
    background: linear-gradient(135deg, #1f8fff 0%, #36c2ff 100%) !important;
}

.dark-mode .topbar-earn-trigger {
    color: var(--text-regular) !important;
}

.dark-mode .topbar-earn-trigger:hover {
    color: #409eff !important;
    background: var(--hover-bg) !important;
}

.dark-mode .topbar-user-wrap {
    background: var(--tag-bg) !important;
}

.dark-mode .topbar-user-link {
    color: var(--text-primary) !important;
}

.dark-mode .topbar-user-link:hover {
    background: var(--hover-bg) !important;
}

.dark-mode .topbar-logout {
    border-left-color: var(--border-color) !important;
}

.dark-mode .topbar-logout:hover {
    color: #f56c6c !important;
    background: rgba(245, 108, 108, 0.1) !important;
}

.dark-mode .dialog-title {
    color: var(--text-primary) !important;
}

.dark-mode .dialog-tip {
    background: var(--tip-bg) !important;
    border-color: var(--tip-border) !important;
    color: var(--text-regular) !important;
}

.dark-mode .dialog-qr-wrap {
    background: var(--bg-card) !important;
    border-color: var(--border-color) !important;
}

.dark-mode .checkin-qr-note {
    color: var(--text-secondary) !important;
}

.dark-mode .topbar-checkin {
    color: #e6a23c !important;
}

.dark-mode .topbar-checkin.checkin-done {
    color: var(--text-secondary) !important;
}
</style>

<style lang="less">
@media (max-width: 768px) {
    .el-message-box__wrapper {
        top: 50% !important;
        transform: translateY(-50%);
        padding-top: 0 !important;
    }
}
</style>





